/**
 * Created by hj on 2017/8/24.
 * change by Jession on 2018/04/04
 * 财务管理 -- 应付记录
 */
import React from 'react';
import {Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon, Modal} from 'antd';
import {hashHistory} from 'react-router';
import {DmsTab, TableView, FilterBox, AdvanceFormNew} from 'Components';
import {openNotice, exportExcel, objectSerial, config} from 'Utils';
import {getPaymentList, addRiskPay} from '../../service/financialMgm';
import moment from 'moment';

class PaymentList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['应付记录'],
            showHideBtnIndex: 0,
            key: 0,
            filterBoxVisible: false,
            rows: [
                // {
                //   id: 1,
                //   name: 'jsy20171229001',
                //   cname: '金胜义',
                //   date: '2017-08-24',
                //   amount: 1000,
                //   remain: 10,
                //   type: '对公转账',
                //   remark: 'asddddddddddddd'
                // },
                // {
                //   id: 2,
                //   name: 'jsy20171229002',
                //   cname: '金胜义',
                //   date: '2017-12-24',
                //   amount: 20,
                //   remain: 10,
                //   type: '对公转账',
                //   remark: '123123123123'
                // }
            ],
            total: 1,
            searchObj: {
                /*q: '',
                effectStartDate: '',
                effectEndDate: '',
                status: '',*/
                cusname: '',  // 客户名称
                cusShortName: '',  // 客户缩写
                riskType: '', // 费用类型
                startDate: '',  // 开始时间
                endDate: '',  // 结束时间
                s: 10,
                p: 1
            },
            visible: false,
            payInfo: {
                riskId: '', // 应付id
                riskDate: moment(new Date()), // 付款日期
                riskCount: '' // 付款金额
            },
            loading: true,
            riskCountShould: 0,
            riskCountReal: 0,
            writenoffCount: 0
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    }

    advanceReset() {
        /* 重置 */
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                /*q: '',
                effectStartDate: '',
                effectEndDate: '',
                status: '',*/
                cusname: '',  // 客户名称
                cusShortName: '',  // 客户缩写
                riskType: '', // 费用类型
                startDate: '',  // 开始时间
                endDate: '',  // 结束时间
                s: 10,
                p: 1
            }
        }, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        });
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
    };

    advanceSubmit(form) {  // 查询
        // openNotice('success', '操作成功', '');
        // this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
        this.setState({searchObj: {...this.state.searchObj, p: 1}}, () => {
            this.initData();
            this.setState({filterBoxVisible: !this.state.filterBoxVisible});
        })
    };

    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    startDate: value.from ? (value.from + ' 00:00:00') : '',
                    endDate: value.end ? (value.end + ' 23:59:59') : ''
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    pageChange(page, pageSize) {
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, () => {
            this.initData();
        })
    }

    goView(url) {
        hashHistory.push(url);
    }

    toEdit(index) {
    }

    showHideBtn(index) {
        this.setState({
            showHideBtnIndex: index
        });
    }

    hideBtn() {
        this.setState({
            showHideBtnIndex: ''
        });
    }

    exportExcel() {
        let params = this.state.searchObj;
        let url = `${config.server}/api/v1/dms/trans/risk/exportRisk?${objectSerial(params)}`;
        window.open(url);
    }

    handleOk = () => {  // 付款
        // console.log(this.state.payInfo);
        let param = this.state.payInfo;
        param.riskDate = param.riskDate.format('YYYY-MM-DD HH:mm:ss');
        // console.log(param);
        addRiskPay(param).then(result => {
            console.log(result);
            if (result.status) {
                this.setState({
                    visible: false,
                    payInfo: {
                        riskId: '', // 应付id
                        riskDate: moment(new Date()), // 付款日期
                        riskCount: '' // 付款金额
                    }
                }, () => {
                    openNotice('success', '付款成功', '');
                    this.initData();
                });
            } else {
                message.error(result.message);
            }
        });
    }

    handleCancel = () => {
        this.setState({visible: false});
        this.setState({
            payInfo: {
                riskId: '', // 应付id
                riskDate: moment(new Date()), // 付款日期
                riskCount: '' // 付款金额
            }
        });
    }

    payFun = (record) => {
        this.setState({
            visible: true,
            payInfo: {
                ...this.state.payInfo,
                riskId: record.id
            },
            riskCountShould: record.riskCountShould,
            riskCountReal: record.riskCountReal,
            writenoffCount: record.writenoffCount
        });
    }

    dateOnChange = (date, dateString) => {  // 付款日期选择
        // console.log(dateString);
        // console.log(this.state);
        // let thisDate = date.format('YYYY-MM-DD HH:mm:ss');
        // let thisDate = moment(date).format('YYYY-MM-DD HH:mm:ss');
        // console.log(thisDate);
        this.setState({payInfo: {...this.state.payInfo, riskDate: date}})
    }

    amountOnChange = (event) => { // 付款金额填写
        // console.log(event.target.value);
        if (event.target.value < 0) {
            return
        }
        if (event.target.value > this.state.riskCountShould - this.state.riskCountReal - this.state.writenoffCount) {
            return
        }
        this.setState({payInfo: {...this.state.payInfo, riskCount: event.target.value}})
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        this.setState({
            loading: true
        })
        getPaymentList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total,
                    loading: false
                })
            } else {
                message.error(result.message);
            }
        })
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
    }

    render() {
        const {
            opts, key, filterBoxVisible, rows, total, searchObj, showHideBtnIndex, visible, payInfo, loading, riskCountShould,
            riskCountReal,
            writenoffCount
        } = this.state;
        var self = this;
        const advanceProps = {
            fileds: [
                {
                    name: 'cusName',
                    label: '客户名称',
                    text: '输入客户名称',
                    type: 'default',
                    defaultValue: searchObj.cusname
                },
                // {
                //   name: 'cusShortName',
                //   label: '客户缩写',
                //   text: '输入客户缩写',
                //   type: 'default',
                //   defaultValue: searchObj.cusShortName
                // },
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '日期',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.from || '',
                        end: searchObj.end || ''
                    }
                },
                {
                    name: 'riskType',
                    label: '费用类型',
                    text: '选择费用类型',
                    options: [
                        {value: '', text: '全部'},
                        {value: '返利', text: '返利'},
                        {value: '佣金', text: '佣金'},
                        {value: '退货', text: '退货'},
                        {value: '其他', text: '其他'}
                    ],
                    multiple: false,
                    type: 'select',
                    defaultValue: searchObj.riskType || ''
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '编号',
                    dataIndex: 'riskCode',
                    render: (text, record, index) => {
                        return <a href={`#/payment/detail/${record.id}`}>{text}</a>
                    }
                },
                {
                    title: '客户名称',
                    dataIndex: 'cusName'
                },
                {
                    title: '日期',
                    dataIndex: 'riskDate',
                    render: (text, record, index) => {
                        return new Date(record.riskDate).format('yyyy-MM-dd');
                    }
                },
                {
                    title: '应付金额',
                    dataIndex: 'riskCountShould',
                    render: (text, record, index) => {
                        return record.riskCountShould || 0;
                    }
                },
                {
                    title: '已付金额',
                    dataIndex: 'riskCountReal'
                },
                {
                    title: '已核销订单金额',
                    dataIndex: 'writenoffCount'
                },
                {
                    title: '可核销金额',
                    dataIndex: 'writenoffCountAble'
                },
                {
                    title: '费用类型',
                    dataIndex: 'riskType'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '操作',
                    dataIndex: 'action',
                    render: (text, record, index) => {
                        return (
                            <div>
                              {/*  <Button style={{marginRight: 10}}
                                        onClick={this.payFun.bind(this, record)}>付款</Button>*/}
                                <Button onClick={this.goView.bind(this, {
                                    pathname: `/payment/edit/${record.id}`,
                                    state: record
                                })}>核销</Button>
                            </div>
                        )
                    }
                }
            ],
            rows
        };
        return <div className="dms-body">
            <DmsTab options={opts} defaultKey={key}></DmsTab>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps}/>
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button onClick={this.goView.bind(this, '/payment/add/0')}
                            style={{position: 'absolute', bottom: 8, left: 0}}>新增</Button>
                    <Button style={{marginLeft: 10}} onClick={this.exportExcel.bind(this)}
                            style={{position: 'absolute', bottom: 8, right: 0}} icon="export">导出</Button>
                </div>
                <TableView {...tableViewProps}/>
            </div>

            <Modal
                visible={visible}
                title="付款"
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                maskClosable={false}
            >
                <div>
                    <Row style={{marginBottom: 10}}>
                        <Col>
                            <label className="ant-form-item-required">付款日期</label>
                            <DatePicker style={{marginLeft: 50}} onChange={this.dateOnChange} value={payInfo.riskDate}
                                        defaultValue={moment(new Date())}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label className="ant-form-item-required">金额</label>
                            <Input style={{marginLeft: 50, width: 185}} onChange={this.amountOnChange}
                                   value={payInfo.riskCount}
                                   type='number'
                                   min={0} max={riskCountShould - riskCountReal - writenoffCount} step={1}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    }
}
;
export default PaymentList;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/paymentList.js